import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  articles: {},
});

export function merge(state, article) {
  const arr = Array.isArray(article) ? article : [article];
  return state
    .mergeIn(['articles'], fromJS(arr.reduce((obj, art) => ({ ...obj, [art.id]: art }), {})));
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ARTICLES_SET':
      return merge(state, action.articles);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/articles.js